import React from "react";
import styled from "styled-components";
import {
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
} from "../index.styled";
import { ReactComponent as WheelChair } from "../../../Assets/Icons/WheelChair.svg";
import { viewSizeCalculator } from "../../../utils";

const AccessibilityAndInclusivity = ({ data, reference }) => {
  const fields = data.fields;
  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <WheelChair />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer>
          {fields.map((ele, ind) => (
            <CheckboxContainer>
              <input
                style={{
                  cursor: "pointer",
                  accentColor: "#F96250",
                  width: viewSizeCalculator(1.063),
                  height: viewSizeCalculator(1.063),
                }}
                type="checkbox"
                id={ele.label}
              />
              <CheckboxLabel htmlFor={ele.label}>{ele.label}</CheckboxLabel>
            </CheckboxContainer>
          ))}
        </RowContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default AccessibilityAndInclusivity;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: 20px;

  width: ${({ width }) => width || "70%"};
`;
